import { usePresence } from '../presence/usePresence.js';
import { useServices } from '../services.js';
import { useNarrow } from '../ui/useNarrow.js';
import { RecentMeetings } from './RecentMeetings.js';
import { RoomTabs } from './RoomTabs.js';
import { Search } from './Search.js';

export function HomePage() {
  const { api } = useServices();
  const presence = usePresence(api);
  const narrow = useNarrow();
  return (
    <div className={narrow ? 'home home--narrow' : 'home'}>
      <RoomTabs presence={presence} narrow={narrow} />
      <div className="home__columns">
        <RecentMeetings />
        <Search />
      </div>
    </div>
  );
}
